import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const OutsideLink = ({
  size,
  type,
  theme,
  className,
  dataTestId = "outside-link-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M2.5 2.667C2.5 2.299 2.8 2 3.167 2h4.666a.667.667 0 0 0 0-1.333H3.167a2 2 0 0 0-2 2v10.667a2 2 0 0 0 2 2h10.666a2 2 0 0 0 2-2V8.667a.667.667 0 0 0-1.333 0v4.667a.667.667 0 0 1-.667.666H3.167a.667.667 0 0 1-.667-.666V2.667Z" />
    <path d="M11.167.667a.667.667 0 0 0 0 1.333h2.39L6.03 9.53a.667.667 0 1 0 .942.943l7.53-7.529v2.39a.667.667 0 0 0 1.332 0v-4a.667.667 0 0 0-.666-.666h-4Z"
    />
  </SVGIcon>
);
